<template>
  <div class="big-map-box">
    <div class="map-title">{{ title }}</div>
    <div class="map-content" id="heatMap"></div>
    <div class="map-darkcorner"></div>
    <div class="btn-radius set-fitview" @click="layer.setFitView()" v-if="fitviewBtnFlag">归位</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Heatmap',
  props: {
    title: {
      type: String,
      default: ""
    },
    heatmapData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      map: null,
      layer: null,
      fitviewBtnFlag: false
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.map = new AMap.Map("heatMap", {
        mapStyle: "amap://styles/b5500447492ee5d38f79824b6e68aec4",
        zoom: 10
        // features: ["bg", "road"]
      });
      setInterval(() => {
        this.map.on('mapmove', () => {
          this.fitviewBtnFlag = true
        })
      }, 1000)
      this.initLayer();
    },
    initLayer() {
      this.layer = new Loca.HeatmapLayer({
        map: this.map
      });
      var list = [];
      var i = -1,
        length = this.heatmapData.length;
      while (++i < length) {
        var item = this.heatmapData[i];
        list.push({
          coordinate: [item.lng, item.lat],
          count: item.count
        });
      }
      this.layer.setData(list, {
        lnglat: "coordinate",
        value: "count"
      });

      this.layer.setOptions({
        style: {
          radius: 30,
          color: {
            0.3: "#357efe",
            0.5: "#92f630",
            0.7: "#ffd716",
            0.9: "#ff7c1c",
            1.0: "#f61b1f"
          }
        }
      });
      this.layer.render();
      setTimeout(() => {
        this.layer.setFitView();
      }, 0);
    }
  }
};
</script>

<style scoped lang="less"></style>
